import { LightType } from '@inter-ikea-betrakta/viewer';
import LightSource from './LightSource';
class SpotLightSource extends LightSource {
    constructor(viewer, parentId, intensity, color, worldPosition, lightSourceWidth, lightDirection, visible, angle) {
        super(viewer, color);
        this.sourceModelId = viewer.create_sphere(5, lightSourceWidth / 1000, this.viewer.create_material());
        this.setSourceModelId(this.sourceModelId);
        viewer.set_parent(this.sourceModelId, parentId);
        viewer.set_scale(this.sourceModelId, 4.2, 1, 4.2);
        viewer.set_position(this.sourceModelId, worldPosition.X / 1000, worldPosition.Y / 1000, worldPosition.Z / 1000);
        viewer.set_visible(this.sourceModelId, visible);
        this.light = viewer.create_light(LightType.SPOT_LIGHT);
        this.light.intensity = intensity;
        this.light.direction?.set(lightDirection.X, lightDirection.Y, lightDirection.Z);
        this.light.parent = this.sourceModelId;
        this.light.position.set(0, 0, 0);
        this.light.intensity_affects_parent_emission_color = true;
        this.light.color.set(color.r, color.g, color.b);
        this.light.radians = angle;
        //this.light.outer_angle_radians = 93 * (Math.PI / 180); // This will be set after merge to master
        // colorTemperature !== 0 && this.light.set_color_temperature(colorTemperature);
    }
}
export default SpotLightSource;
//# sourceMappingURL=SpotLightSource.js.map